import React, { useEffect, useState, useRef } from 'react';
import BotMessage from '../ChatBody/BotMessage';
import UserMessage from '../ChatBody/UserMessage';
import WelcomeScreen from "../ChatBody/WelcomeScreen"
import Feedback from "../ChatBody/Feedback";
import BotTyping from "../ChatBody/BotTyping";
import ConnectingAgent from "../ChatBody/ConnectingAgent";
import QuickResponce from "../ChatBody/QuickResponce";
import BigImage from "../ChatBody/BigImage";
import { languages } from '../../utility/constants'
import base32 from '../../../cryptographic/encoder';
import { btoa, toUnicode, atob } from '../../../cryptographic/crypto';
import BotOffline from "../ChatBody/BotOffline";
import ringtone from "./../NotificationSound/notify.mp3"
import SelectLang from '../../pages/SelectLang';
import ThankYou from '../ChatBody/ThankYou';
import { setCookie, getCookie, readCookie, updateCookie, deleteCookie, updateAllCookiesExpiry, deleteAllCookies } from '../../utility/cookies';
import Loading from './Loading';
import useSpeechSynthesis from '../../utility/useSpeechSynthesis';
import ImageUploader from '../ChatBody/ImageUploader';
import PdfSideView from '../ChatBody/PdfSideVIew';
import MessageList from './MessageList';
import { Connection } from '../../components/socketHandler/socketEventsHandler';
import { subscriber } from "../../components/socketHandler/subsPubs";

var messages = [];
var chatBackups = [];
let language = languages
var botFirstMsg = []
const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
};

let callEvents = new Connection();

const formatDate = (date) => {
    const currentDate = new Date(date);
    const day = currentDate.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[currentDate.getMonth()];
    return `${day} ${month}`;
}
let scheduedReplay;
let sound = new Audio(ringtone);
function ChatBody({ isLangChange, setmessageSender, setCloseChatEff, setMessage, message, setMessageOnReload,
    messageOnReload, langisClicked, closeChatEff, setCloseFloat, setChatIsClose, chatIsClose,
    openChat, changeLanguage, filteredLang, noFeedback, setNoFeedback, prefLang, setPrefLang, isLang,
    setIsLang, setStartChat, startChat, openBot, setOpenBot, openAbout, openFeedback, setOpenFeedback,
    events, socket, formRequested, setFormRequested, agentName, botImage, botInfo, hiSendChat, setHiSendChat,
    userLastMsg, voiceEnabled, hideFooter, setHideFooter, openMic, setBlockMic, scroll, messagesEnd, setSideViewer,
    pdfSideViwer, setShowNoChatWrap, showNoChatWrap, disableResp, setDisableResp, setShowPopularSearch2, suggestHeight,
    setOpenImage, OpenImage }) {
    const [quickRes, setQuickRes] = useState()
    const [appointment, setAppointment] = useState()
    const [hideACall, setHideACall] = useState(true)
    const currentLang = getCookie('prefLang')
    const [baOrAb, setBaOrAb] = useState(false);
    const [transferMessage, setTransferMessage] = useState('');
    const [formData, setFormData] = useState([])
    const [botAgentIcon, setBotAgentIcon] = useState(false)
    const [postFormData, setPostFormData] = useState([])
    const [openPreChatBody, setOpenPreChatBody] = useState(false)
    const [messageSent, setMessageSent] = useState(false)
    const [typing, setTyping] = useState(false)
    const [incomingTone, setIncomingTone] = useState(false)
    const [sessionID, setSessionID] = useState(null)
    const [groupID, setGroupID] = useState(null)
    let chatsBackUp = [];
    const windowGroupId = process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : "6rv32rv2c4tp2c9qchgkad1ncmvk4t326rup6cg"
    const [filterLang, setFilterLang] = useState(null)
    const [messageOnLoad, setMessageOnLoad] = useState('')
    const [locale, setLocale] = useState(prefLang)
    const [preChatData, setPreChatData] = useState([])
    const [hideIframe, setHideIframe] = useState(true)
    const [ssmlText, setSSmlText] = useState("")
    const wasAtBottomRef = useRef(true);
    const scrollableDivRef = useRef(null);

    var voiceLang = languages?.find(lang => lang.value === prefLang)
    const onEnd = () => {
        cancel();
        setSpeaking(false)
        setBlockMic(false)
    };

    const { speak, voices, cancel, setSpeaking } = useSpeechSynthesis({
        onEnd,
    });

    const isMobile = () => {
        // Check if running in a mobile browser or app
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Regular expressions to detect mobile browsers
        const mobilePatterns = [
            /android/i,
            /iphone/i,
            /ipad/i,
            /ipod/i,
            /windows phone/i,
            /blackberry/i,
            /opera mini/i,
            /iemobile/i
        ];

        // Check if userAgent matches any mobile patterns
        return mobilePatterns.some(pattern => pattern.test(userAgent));
    }
    var voiceAssist = (isMobile() && process.env.REACT_APP_CLIENT === "GEMS") ? "" : window?.speechSynthesis?.getVoices()?.find(voice => voice.name === getCookie("voiceAssistant"))
    var voiceAssist2 = (isMobile() && process.env.REACT_APP_CLIENT === "GEMS") ? "" : window?.speechSynthesis?.getVoices()?.filter((f) => (f.name.includes("Google") && !f.lang.includes("de-DE")) || f.name.includes("Karen") || f.name.includes("Daniel") || f.name.includes("Rishi") || f.name.includes("Samantha") || f.name.includes("Tessa") || f.name.includes("Monica"))
    var voiceAssist3 = (isMobile() && process.env.REACT_APP_CLIENT === "GEMS") ? "" : voiceAssist2?.filter((f) => f?.lang.includes(voiceLang?.value))?.length > 0 ? voiceAssist2?.filter((f) => f?.lang.includes(voiceLang?.value))[0] : voiceAssist2[0]

    useEffect(() => {
        if (voiceAssist3?.name !== undefined) {
            if (voiceAssist3?.length > 0) {
                updateCookie("voiceAssistant", voiceAssist3?.name)
            } else {
                updateCookie("voiceAssistant", voiceAssist3?.name)
            }
        }
    }, [prefLang])

    const scrollBotMessage = () => {
        if (scrollableDivRef.current) {
            try {
                const userMessage = message?.filter((msg) => !msg?.userId)
                const scrollId = userMessage[userMessage?.length - 1].id
                const divId = document.getElementById(scrollId)
                // console.error(userMessage, scrollId)
                if (userMessage?.length > 0 && divId && scrollId) {
                    setTimeout(() => {
                        document.getElementById(scrollId).scrollIntoView({
                            behavior: "smooth"
                        })
                    }, 500);
                }
            } catch (e) {
                // console.error(e)
            }
        }
    };

    useEffect(() => {
        // scrollToBottom()
    }, [scroll])


    let messageArr1 = []; let messageArr2 = []

    const checkFullBot = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Full" || botType === "TlkDocs") {
            return true
        } else {
            return false
        }
    }

    const [counter, setCounter] = useState(1800000)

    useEffect(() => {
        const newTimer = setTimeout(() => {
            if (counter !== 0) {
                setCounter(counter - 10000)
            }
        }, 10000);
        if (counter === 0) {
            setTimeout(() => {
                if (!getCookie('sessionId')) {
                    resetChatForm()
                }
            }, 1000);
        }
        return () => clearInterval(newTimer)
    }, [counter])

    const resetChatForm = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        setOpenBot(false);
        setIsLang(false)
        setStartChat(false)
        chatBackups = []
        setMessage([])
        deleteCookie("sessionId")
        setMessageOnReload([]);
        setTimeout(() => {
            setCloseChatEff(false)
            setChatIsClose(false)
            setCloseFloat(true)
            updateCookie('formReq', 'false')
            updateCookie('chatStart', 'false')
            updateCookie('hasNoFeedback', 'false')
            updateCookie('hasFeedback', 'false')
            updateCookie('prefLang', null)
            updateCookie('firstMsg', null)
            setNoFeedback(false)
            setIsLang(false)
            setPrefLang(null)
            setStartChat(false)
            setOpenFeedback(false)
            updateCookie('closeChatEff', false)
            updateCookie('appState', 'null')
            deleteCookie('talkkChatState')
            deleteCookie('uInfo')
            deleteCookie('bot')
            socket.disconnect()
            setCloseFloat(false);
            if (botType === "TlkDocs") {
                window.location.reload()
            }
        }, 1000);
    }
    const closeChat = () => {
        socket.emit(btoa(["close-chat", {}]));
        setFormRequested(false)
        setHideFooter(false)
        updateCookie('appState', 'closeChat')
        updateCookie('appState', 'hasFeedback')
    }

    window.globalCloseChatFunction = function () {
        socket.emit(btoa(["close-chat", {}]));
        setFormRequested(false)
        setHideFooter(false)
        updateCookie('appState', 'closeChat')
        updateCookie('appState', 'hasFeedback')
    };

    useEffect(() => {
        console.log(events, "all event message print")
        console.log(chatBackups, messages, message, messageOnLoad, "messages data")
        if (isLang === true) {
            if (Object.keys(events).length > 0) {
                const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
                if (botType !== "TlkDocs") {
                    if (getCookie('sessionId')) {
                        updateAllCookiesExpiry()
                        setCounter(1800000)
                    } else {
                        resetChatForm()
                    }
                }
                if (events["user-send"]) {
                    if (events["user-send"][1].length == 0) {
                    }
                    else {
                        setTyping(true)
                        // updateChatPosition()
                        let encoder = new base32()
                        messages = events["user-send"][1]
                        if (messageOnReload.length > 0) {
                            let userSendMsg = chatsBackUp.filter(elements => elements.id == messageOnReload.id)
                            if (userSendMsg) { }
                            else {
                                chatBackups = [...chatBackups, ...messageOnReload]
                            }
                        }

                        let userSendMessage = chatsBackUp.find(elements => elements.id == events["user-send"][1].message[0].id)
                        if (userSendMessage) {
                        }
                        else {
                            chatBackups = [...chatBackups, events["user-send"][1].message[0]]
                            setMessageOnReload(chatBackups)
                            setMessage(chatBackups);
                            // setDisableResp(true)
                        }
                        setIncomingTone(false)
                        setMessageSent(true)
                        setTimeout(() => {
                            messagesEnd?.current?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                        updateChatPosition()
                    }
                }
                else if (events["agent-message"]) {
                    setTyping(false)
                    setShowPopularSearch2(false)
                    let encoder = new base32();
                    let incomingId = encoder.encode(events["agent-message"][2]);
                    let messages = events["agent-message"][1].message[0]
                    if (messageOnReload.length > 0) {
                        let agentSendMsg = chatsBackUp.filter(elements => elements.id == messageOnReload.id)
                        if (agentSendMsg) { }
                        else {
                            chatBackups = [...chatBackups, ...messageOnReload]
                        }
                    }
                    let agentSendMessage = chatsBackUp.find(elements => elements.id == events["agent-message"][1].message[0].id)
                    if (agentSendMessage) {

                    }
                    else {
                        chatBackups = [...chatBackups, messages]
                        setMessageOnReload(chatBackups)
                        if (messages?.template?.hasOwnProperty('ssml')) {
                            if (voiceEnabled && openMic) {
                                const SSML = messages?.template?.ssml?.replace(/(<([^>]+)>)/gi, "")
                                setSSmlText(SSML)
                                if (getCookie("voiceAssistant")) {
                                    cancel();
                                    setSpeaking(true);
                                    setBlockMic(true);
                                    speak({ text: SSML, voice: voiceAssist, lang: voiceLang?.lang_enable ? voiceLang?.locale : "en-GB" })

                                } else {
                                    cancel();
                                    setSpeaking(true);
                                    setBlockMic(true);
                                    speak({ text: SSML, voice: voiceAssist3, lang: voiceLang?.lang_enable ? voiceLang?.locale : "en-GB" })
                                }
                            }
                        }

                        if (messages?.template?.template?.elements?.buttons?.filter(component => component.mode === "close_conversation").length) {
                            closeChat()
                        }
                        if (!messages?.template?.hasOwnProperty('ssml')) {
                            setMessage(chatBackups);
                        } else if (messages?.template?.hasOwnProperty('ssml')) {
                            if (Object.keys(messages?.template).length > 1) {
                                setMessage(chatBackups);
                            }
                        } else {
                            setMessage(chatBackups);
                        }

                        if (messages?.template?.template?.elements?.buttons?.filter(component => component.mode === "disable_text_box").length) {
                            setHideFooter(true)
                        } else {
                            if (!messages?.template?.hasOwnProperty('ssml')) {
                                setHideFooter(false)
                            }
                        }
                    }

                    if (events["agent-message"][1]?.message[0]?.userId?.isBot === "N") {
                        setmessageSender(events["agent-message"][1]?.message[0]?.userId?.displayName)
                    } else {
                        setmessageSender("bot")
                    }


                    if (events["agent-message"][1].message[0]) {
                        setIncomingTone(true)
                    }
                    else {
                        setIncomingTone(false)
                    }
                    if (events["agent-message"][1].message[0].template.transfer) {
                        if (events["agent-message"][1].message[0].template.transfer == 'AC') {
                            setHideACall(false)
                        }
                        if (events["agent-message"][1].message[0].template.transfer == 'BA') {
                            setTransferMessage(events["agent-message"][1].message[0].template.template.elements.title)
                            setBotAgentIcon(true)
                            setBaOrAb(true)
                            setHideACall(true)
                        }
                        if (events["agent-message"][1].message[0].template.transfer == 'AB') {
                            setTransferMessage(events["agent-message"][1].message[0].template.template.elements.title)
                            setBotAgentIcon(true)
                            setBaOrAb(false)
                        }
                    }
                    if (!messages?.template?.hasOwnProperty('ssml')) {
                        scrollBotMessage()
                    }
                    var sendData1 = {};
                }
                else if (events["user-message"]) {
                    if (events["user-message"][1].length == 0 && !startChat) {
                        setIncomingTone(false)
                        if (getCookie('talkkChatState') !== 1) {
                            // socket.emit(btoa(["request-form", { group: windowGroupId }]));
                            setIncomingTone(false)
                            let langAfterReload = getCookie('prefLang')
                            if (langAfterReload != undefined && langAfterReload != null) {
                                let langArr = botInfo?.data?.leadForm
                                if (langArr && botType !== "TlkDocs") {
                                    if (botInfo?.data?.leadForm) {
                                        setFormData(botInfo.data.leadForm)
                                        if (langArr === undefined || langArr === null) {
                                            setStartChat(true)
                                            setFormRequested(false)
                                            updateCookie('appState', 'chatTrue')
                                            updateCookie('hasPrechat', false)
                                        }
                                        else {
                                            let formLang = langArr[prefLang]
                                            if (!formLang) {
                                                setFormRequested(false)
                                                updateCookie('appState', 'chatTrue')
                                                updateCookie('hasPrechat', false)
                                                setStartChat(true)
                                            }
                                            else if (formLang.length > 0) {
                                                if (getCookie('appState') === 'chatTrue') {
                                                    setFormRequested(false)
                                                    updateCookie('appState', 'chatTrue')
                                                    updateCookie('hasPrechat', false)
                                                    setStartChat(true)
                                                }
                                                else {
                                                    setFormRequested(true)
                                                    chatBackups = []
                                                    updateCookie('hasPrechat', true)
                                                    updateCookie('appState', 'hasPrechat')
                                                    setStartChat(false)
                                                    setPreChatData(formLang)
                                                }
                                            }
                                            else {
                                                setFormRequested(false)
                                                updateCookie('hasPrechat', false)
                                                updateCookie('appState', 'chatTrue')
                                                setStartChat(true)
                                            }
                                        }
                                    } else {
                                        setStartChat(true)
                                        setFormRequested(false)
                                        updateCookie('appState', 'chatTrue')
                                        updateCookie('hasPrechat', false)
                                    }
                                } else {
                                    setStartChat(true)
                                    setFormRequested(false)
                                    updateCookie('appState', 'chatTrue')
                                    updateCookie('hasPrechat', false)
                                }
                            }
                        }

                    } else {
                        updateCookie('appState', 'chatTrue')
                        let encoder = new base32()
                        let messages = events["user-message"][1]
                        let chatWindowMsgs = chatsBackUp.find(elements => elements.id == events["user-message"][1].id)

                        if (chatWindowMsgs) {

                        }
                        else {

                            messages.forEach((item, index) => {
                                messageArr1.push(item)
                                if (item[index]?.userId) {
                                }
                                else {

                                    if (locale !== null && item?.locale !== undefined && item?.locale !== locale) {
                                        setLocale(item?.locale)
                                        var langname = filterLang?.filter(lang => lang.value === item?.locale)

                                        const date = new Date();
                                        let dateId = Math.floor(date.getTime() / 1000)
                                        if (langname !== undefined) {
                                            if (dateId === null || item?.locale === null || langname === null || item?.locale === undefined) {

                                            }
                                            else {
                                                messageArr1.push({ id: dateId, text: 'languageChange', lang: item?.locale, langName: langname })

                                            }
                                        }
                                    }
                                }
                            })
                            setMessageOnReload(messageArr1);
                            setMessageOnLoad(true)
                            updateCookie('firstMsg', 'sent')
                        }
                        setCookie("talkkChatState", 1, 1)
                        setSessionID(message[0]?.conversationId?.sessionToken)
                        setGroupID(message[0]?.groupId?.Id)
                        // scrollToBottom()
                    }
                }
                else if (events["agent-typeing"]) {
                    setIncomingTone(false)
                    setTyping(true)
                    if (events["agent-typeing"][1].status === "E") {
                        setTyping(false)
                    }
                    else if (events["agent-typeing"][1].status === "A") {
                        setTyping(true)
                    }
                } else if (events["close-chat"]) {
                    setSideViewer({ show: false, url: "" })
                    setCloseChatEff(true)
                    setCookie('closeChatEff', true, 1)
                    setMessage([])
                    setMessageOnReload([])
                    setStartChat(false)
                    if (chatBackups?.length > 0) {
                        botFirstMsg = chatBackups[0]
                    }
                    chatBackups = []
                    messages = []
                    if (events["close-chat"].success === '1') {
                        setMessage([])
                        setMessageOnReload([])
                        setStartChat(false)
                    }
                    const newPostFormData = botInfo?.data?.postForm
                    if (newPostFormData && newPostFormData[prefLang] && botType !== "TlkDocs") {
                        setStartChat(false)
                        let postFormVar = newPostFormData[prefLang]
                        setPostFormData(postFormVar)
                        if (postFormVar === undefined || postFormVar === null) {
                            updateCookie('appState', 'null')
                            setOpenFeedback(false)
                            setNoFeedback(false)
                            setFormRequested(false)
                        }
                        else if (postFormVar.length > 0) {
                            setFormRequested(false)
                            updateCookie('appState', 'hasFeedback')
                            setOpenFeedback(true)
                            setNoFeedback(false)
                        }
                        else if (postFormVar.length === 0) {
                            updateCookie('appState', 'hasNoFeedback')
                            setOpenFeedback(true)
                            setNoFeedback(true)
                        }
                        else {
                            updateCookie('appState', 'hasNoFeedback')
                            setOpenFeedback(true)
                            setNoFeedback(true)
                        }
                    } else {
                        // if (botType === "TlkDocs"){
                        //     window.location.reload()
                        // }
                        resetChatForm()
                    }
                }
                else if (events["conversation-counts"]) {
                    setChatIsClose(true)
                } else if (events["auth_success"]) {
                    setHideIframe(!hideIframe)
                    let sendData = {
                        text: toUnicode(userLastMsg),
                        notification: 'N',
                    }
                    socket.emit(btoa(["user-send", sendData]));
                }
            }
        }
    }, [events])

    useEffect(() => {
        let messagesGet = [];
        if (messageOnReload.length > 0) {
            let localeVal = getCookie('firstLang')
            messageOnReload.forEach((item, index) => {
                messageArr2.push(item);
                if (item?.userId) {
                }
                else {
                    if (localeVal !== null && item?.locale !== undefined && item?.locale !== localeVal) {
                        localeVal = item?.locale
                        var langname = filterLang?.filter(lang => lang.value === item?.locale)
                        const date = new Date();
                        let dateId = Math.floor(date.getTime() / 1000)
                        if (langname !== undefined) {
                            if (dateId === null || item?.locale === null || langname === null || localeVal === undefined) {

                            }
                            else {
                                messageArr2.push({ id: dateId, text: 'languageChange', lang: item?.locale, langName: langname })
                            }
                        }
                    }
                }
                setMessage(messageArr2)
            })
            messagesGet = [...messagesGet, ...messageArr2];
        }
        else if (formRequested === false && startChat === true && messageOnReload.length === 0) {
            if (checkFullBot() === false) {
                startChatWithHi()
            }
        }
        if (chatBackups?.length > 0) {
            if (messageArr2.length > 0) {
                let chatWindowMsgs = chatBackups.filter(elements => elements.id !== messageOnReload.id)
                if (chatWindowMsgs) { }
                else {
                    chatBackups = [...chatBackups, ...messageArr2]
                }
            }
            else {
                chatBackups = [...chatBackups]
            }
            setMessage(chatBackups)
        }
        else {
            if (messageArr2.length > 0) {
                chatBackups = [...chatBackups, ...messageArr2]
            }
            else {
                chatBackups = [...chatBackups]
            }
            setMessage([...chatBackups])
        }
        let closeChatEff = getCookie('closeChatEff');
        let hasFeedback = getCookie('hasFeedback')
        if (closeChatEff === true && hasFeedback === true) {
            setCloseChatEff(false)
            setChatIsClose(false)
            chatBackups = [];
            setNoFeedback(false)
            deleteCookie('prefLang')
            deleteCookie('hasNoFeedback')
            deleteCookie('formReq')
            deleteCookie('hasFeedback')
            deleteCookie('chatStart')
            setIsLang(false)
            setPrefLang(null)
            setStartChat(false)
            setFormRequested(false)
            setOpenFeedback(false)
            setNoFeedback(false)
            chatBackups = {}
            deleteCookie('talkkChatState')
            deleteCookie('uInfo')
            deleteCookie('bot')
            socket.disconnect()
        }
    }, [openBot, startChat, messageOnLoad])

    useEffect(() => {
        updateCookie('newChat', true);
        setFilterLang(language.filter((lang) => botInfo?.data?.bot?.language.includes(lang.value)))
    }, [botInfo])

    useEffect(() => {
        if (langisClicked !== '') {
            const date = new Date();
            let dateId = Math.floor(date.getTime() / 1000)
            let filterLangMsg = chatBackups?.find(elements => elements.id === dateId)
            var langname = filterLang?.filter(lang => lang.value === prefLang)
            if (filterLangMsg) {

            }
            else {
                if (langname !== undefined) {
                    if (dateId === null || prefLang === null || langname === '' || langname === null) {
                    }
                    else {
                        chatBackups = [...chatBackups, { id: dateId, text: 'languageChange', lang: prefLang, langName: langname }]
                    }
                    setMessage(chatBackups)
                }
            }
        }
    }, [langisClicked])

    useEffect(() => {
        if (incomingTone === true) {
            sound.play();
        } else if (incomingTone === false) {
            sound.pause();
        }
        else {
            sound.stop();
        }
    }
        , [incomingTone])

    const startChatWithHi = () => {
        if (getCookie('firstMsg') !== 'sent') {
            let sendData = {}
            if (prefLang != null) {
                sendData = {
                    text: toUnicode("/st_greetings"),
                    notification: 'N',
                    locale: prefLang
                }
            }
            else {
                sendData = {
                    text: toUnicode("/st_greetings"),
                    notification: 'N',

                }
            }
            let obj = {};
            sendData.info = obj;
            if (window?.access_token) {
                sendData.info.access_token = window.access_token;
            }
            if (window?.user_id) {
                sendData.info.user_id = window.user_id;
            }
            function isEmpty(obj2) {
                return Object.keys(obj2).length === 0 && obj2.constructor === Object;
            }
            if (!isEmpty(obj)) {
                setCookie("uInfo", btoa(sendData))
            }
            setCookie("talkkChatState", 1, 1)
            setCookie('bot', "6rt6cc3165hp2tb26cr30d1p6ngkge3164r34e8", 1);
            updateCookie('appState', 'chatTrue')
            updateCookie("prefLang", prefLang)
            socket.emit(btoa(["user-send", sendData]));
        }
    }

    const updateChatPosition = () => {
        const el = scrollableDivRef.current;
        if (!el) return;

        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;

        const offsetFromBottom = scrollHeight - scrollTop - clientHeight;
        const isAtBottom = offsetFromBottom < 100; 
        wasAtBottomRef.current = isAtBottom
    }

    const handleChatScroll = () => {
        const el = scrollableDivRef.current;
        if (!el) return;

        if (wasAtBottomRef.current) {
            el.scrollTop = el.scrollHeight - el.clientHeight - 200;
        } else {
            el.scrollTop = el.scrollHeight;
        }
    }
    const scrollToBottom = () => {
        handleChatScroll()
    }

    const handleScroll = () => {
        const el = scrollableDivRef.current;
        if (!el) return;
    
        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;
    
        const offsetFromBottom = scrollHeight - scrollTop - clientHeight;
      };
    
      useEffect(() => {
        const el = scrollableDivRef.current;
        if (!el) return;
        el.addEventListener('scroll', handleScroll);
    
        handleScroll();
    
        return () => {
          el.removeEventListener('scroll', handleScroll);
        };
      }, []);

    const showFullImage = (Imgsrc) => {
        setOpenImage({ show: true, src: Imgsrc })
    }

    const [btnTypeG, setbtnTypeG] = useState("chat")

    const checkBotType = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Mobi" || botType === "Full" || botType === "TlkDocs") {
            return "true"
        } else {
            return "false"
        }
    }

    useEffect(() => {
        console.log(message, "message 786")
        if (message?.length > 0) {
            setShowNoChatWrap(false)
        } else {
            setShowNoChatWrap(true)
        }
    }, [message])


    useEffect(() => {
        console.log(formRequested, startChat, "startchat 723");
    }, [formRequested, startChat])

    const handleCloseChat = () => {
        closeChat()
        closeChat()
    }


    return (
        <>
            {
                <div ref={scrollableDivRef} className={`chat-body-wrapper ${hideFooter ? "has-no-footer" : ""} ${botInfo?.data?.appInfo?.themeStyle === "style2" || botInfo?.data?.appInfo?.themeStyle === "style4" ? "has-curved-nib" : ""} ${botInfo?.data?.appInfo?.themeStyle === "style3" || botInfo?.data?.appInfo?.themeStyle === "style4" ? "has-bot-image" : ""}  ${openAbout ? "has-about-modal" : ""}  ${startChat === true ? "has-chat-screen" : ""}  ${openFeedback === true ? 'hide-typebar' : ''} ${noFeedback === true ? 'hide-typebar' : ''}`}>
                    <PdfSideView pdfSideViwer={pdfSideViwer} setSideViewer={setSideViewer} />
                    <div id="closeChatBtn" className='hidden-closec-btn' onClick={() => handleCloseChat()}></div>
                    <BotOffline />
                    {
                        botInfo?.data?.bot?.language.length > 1 && isLang === false && checkBotType() === "true" ?

                            <SelectLang setOpenFeedback={setOpenFeedback} setNoFeedback={setNoFeedback} filterLang={filterLang} botInfo={botInfo} prefLang={prefLang} setPrefLang={setPrefLang} isLang={isLang} setIsLang={setIsLang} />
                            :
                            formRequested === true && startChat === false ?
                                <WelcomeScreen chatsBackUp={chatsBackUp} formRequested={formRequested} setFormRequested={setFormRequested} prefLang={prefLang} setPrefLang={setPrefLang} preChatData={preChatData} setStartChat={setStartChat} startChat={startChat} socket={socket} botInfo={botInfo} />
                                :
                                startChat === true ?
                                    checkFullBot() ?
                                        <>
                                            <MessageList chatsBackUp={chatsBackUp} formRequested={formRequested}
                                                setFormRequested={setFormRequested} prefLang={prefLang} setPrefLang={setPrefLang}
                                                preChatData={preChatData} setStartChat={setStartChat} startChat={startChat} socket={socket}
                                                botInfo={botInfo} showFullImage={showFullImage} chatIsClose={chatIsClose}
                                                closeChatEff={closeChatEff} setChatIsClose={setChatIsClose}
                                                setCloseChatEff={setCloseChatEff} setCloseFloat={setCloseFloat}
                                                setIsLang={setIsLang}
                                                setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback}
                                                setNoFeedback={setNoFeedback} openBot={openBot} setOpenBot={setOpenBot}
                                                setQuickRes={setQuickRes} botImage={botImage} appointment={appointment}
                                                setAppointment={setAppointment} btnTypeG={btnTypeG} setbtnTypeG={setbtnTypeG}
                                                hideIframe={hideIframe} setHideFooter={setHideFooter}
                                                scrollToBottom={scrollToBottom} openMic={openMic} events={events} setSideViewer={setSideViewer}
                                                pdfSideViwer={pdfSideViwer} agentName={agentName} messages={message} disableResp={disableResp} setDisableResp={setDisableResp}
                                                scrollableDivRef={scrollableDivRef} />
                                            <BotTyping typing={typing} setTyping={setTyping} botProfile={botImage} />
                                        </>
                                        :
                                        <>
                                            {
                                                message?.map((item, key) => (
                                                    <div id={item.id}>
                                                        <div style={{ float: "left", clear: "both" }}>
                                                        </div>
                                                        {
                                                            item?.text === 'languageChange' ?
                                                                // <div className="successfully-connected-wrapper">
                                                                //     <div className="content"> {botInfo?.data?.mobileAppConfig?.changeLanguageSet?.[item?.lang] ? botInfo?.data?.mobileAppConfig?.changeLanguageSet?.[item?.lang] : `You can now chat in ${item?.langName[0]?.label}`}</div>
                                                                // </div>
                                                                <></>
                                                                :
                                                                item?.userId ?
                                                                    item?.template.transfer ?
                                                                        (
                                                                            item?.template.transfer == 'AC' ?
                                                                                <div className={`connecting-agent ${hideACall && "hide-call"}`}>
                                                                                    <i className="bot icon-headset-1"></i>
                                                                                    <p>{item?.template?.template?.elements?.title}</p>
                                                                                </div>
                                                                                :
                                                                                item?.template.transfer == 'BA' ?
                                                                                    <div className="successfully-connected-wrapper">
                                                                                        <div className="content">{botInfo?.data?.mobileAppConfig?.connectedTo ? botInfo?.data?.mobileAppConfig?.connectedTo?.[currentLang] : "Connected To"} {item?.userId?.displayName}</div>
                                                                                    </div>
                                                                                    :
                                                                                    <>
                                                                                        <ConnectingAgent to="bot" message={item?.template?.template?.elements?.title} />
                                                                                        <div className="successfully-connected-wrapper show-bot-div">
                                                                                            <div className="content">{botInfo?.data?.mobileAppConfig?.connectedTo ? botInfo?.data?.mobileAppConfig?.connectedTo?.[currentLang] : "Connected To"} {item?.userId?.displayName}</div>
                                                                                        </div>
                                                                                    </>
                                                                        )
                                                                        :
                                                                        item?.messageText ?
                                                                            item?.messageType === "N" ?
                                                                                null
                                                                                :
                                                                                <>
                                                                                    <BotMessage prefLang={prefLang} setPrefLang={setPrefLang} setNoFeedback={setNoFeedback} chatIsClose={chatIsClose} closeChatEff={closeChatEff} setChatIsClose={setChatIsClose} setCloseChatEff={setCloseChatEff} setCloseFloat={setCloseFloat} socket={socket} setIsLang={setIsLang} setFormRequested={setFormRequested} botInfo={botInfo} setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback} openBot={openBot} setOpenBot={setOpenBot} message={item.messageText} agent={item?.userId ? item?.userId?.displayName : agentName} time={formatDate(item.updatedAt) + " | " + new Date(item.updatedAt).toLocaleString("en-US", options)} setStartChat={setStartChat} setQuickRes={setQuickRes} showFullImage={showFullImage} botImage={item?.userId ? item?.userId?.profileImagePath : botImage} isBot={item?.userId?.isBot} appointment={appointment} setAppointment={setAppointment} btnTypeG={btnTypeG} setbtnTypeG={setbtnTypeG} hideIframe={hideIframe} setHideFooter={setHideFooter} indexLength={key} arrayLength={message} prevUser={(message[message[key + 1]?.template?.hasOwnProperty('ssml') ? key + 2 : key + 1]?.userId) ? "bot" : "user"} scrollToBottom={scrollToBottom} openMic={openMic} events={events} setSideViewer={setSideViewer} pdfSideViwer={pdfSideViwer} />
                                                                                </>
                                                                            :
                                                                            item?.messageType === "N" ?
                                                                                null
                                                                                :
                                                                                <>
                                                                                    <BotMessage setPrefLang={setPrefLang} prefLang={prefLang} chatIsClose={chatIsClose} closeChatEff={closeChatEff} setChatIsClose={setChatIsClose} setCloseChatEff={setCloseChatEff} setCloseFloat={setCloseFloat} socket={socket} setIsLang={setIsLang} setFormRequested={setFormRequested} botInfo={botInfo} setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} openBot={openBot} setOpenBot={setOpenBot} message={item} agent={agentName} time={formatDate(item.updatedAt) + " | " + new Date(item.updatedAt).toLocaleString("en-US", options)} setStartChat={setStartChat} setQuickRes={setQuickRes} showFullImage={showFullImage} botImage={botImage} isBot={item?.userId?.isBot} appointment={appointment} setAppointment={setAppointment} btnTypeG={btnTypeG} setbtnTypeG={setbtnTypeG} hideIframe={hideIframe} setHideFooter={setHideFooter} indexLength={key} arrayLength={message} prevUser={(message[message[key + 1]?.template?.hasOwnProperty('ssml') ? key + 2 : key + 1]?.userId) ? "bot" : "user"} scrollToBottom={scrollToBottom} openMic={openMic} events={events} setSideViewer={setSideViewer} pdfSideViwer={pdfSideViwer} />
                                                                                </>
                                                                    :
                                                                    item?.messageType === "N" ?
                                                                        null
                                                                        :
                                                                        <>
                                                                            <UserMessage message={item.messageText} botInfo={botInfo} setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} openBot={openBot} setOpenBot={setOpenBot} time={formatDate(item.updatedAt) + " | " + new Date(item.updatedAt).toLocaleString("en-US", options)} prefLang={prefLang} messageArray={item} showFullImage={showFullImage} scrollToBottom={scrollToBottom} />
                                                                        </>
                                                        }
                                                    </div>
                                                ))
                                            }
                                            <BotTyping typing={typing} setTyping={setTyping} botProfile={botImage} />
                                            <BigImage setOpenImage={setOpenImage} OpenImage={OpenImage} talkktodocs={false} />
                                        </>
                                    :
                                    openFeedback === true && noFeedback === false ?
                                        <Feedback chatBackups={chatBackups} setPrefLang={setPrefLang} setMessage={setMessage} message={message} setMessageOnReload={setMessageOnReload} messageOnReload={messageOnReload} events={events} openFeedback={openFeedback} setIsLang={setIsLang} setOpenBot={setOpenBot} chatIsClose={chatIsClose} setChatIsClose={setChatIsClose} setCloseChatEff={setCloseChatEff} closeChatEff={closeChatEff} setCloseFloat={setCloseFloat} socket={socket} postFormData={postFormData} botInfo={botInfo} groupID={groupID} sessionId={sessionID} setStartChat={setStartChat} setFormRequested={setFormRequested} setOpenFeedback={setOpenFeedback} setNoFeedback={setNoFeedback}
                                            botFirstMsg={botFirstMsg} />
                                        :
                                        formRequested === false && openFeedback === true && noFeedback === true ?
                                            <ThankYou postFormData={postFormData} />
                                            :
                                            <Loading screenName="chatbody" />
                    }
                    <div style={{ marginTop: suggestHeight }}></div>
                    <div ref={messagesEnd}></div>
                </div>
            }
        </>
    )
}
export default ChatBody;
